import { ClaimModel } from 'app/modules/claim/model/claim.model';

export const initialState = {
  loading: false,
  claimsList: [],
  claimListForContract:[],
  redirect: false,
  claimModel: new ClaimModel(),
  page: 1,
  fullClaimList: [],
  redirectLink: null,
};

export type ClaimState = Readonly<typeof initialState>;
